// extracted by mini-css-extract-plugin
export default {"input":"Shipping_input__yK3lu","button":"Shipping_button__I10Gm"};